export default __webpack_public_path__ + "static/media/174.356956b8.png";